import { render, staticRenderFns } from "./create-profile-step-1.vue?vue&type=template&id=2a5fab9a&scoped=true"
import script from "./create-profile-step-1.vue?vue&type=script&lang=js"
export * from "./create-profile-step-1.vue?vue&type=script&lang=js"
import style0 from "./create-profile-step-1.vue?vue&type=style&index=0&id=2a5fab9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5fab9a",
  null
  
)

export default component.exports